import { Injectable } from '@angular/core';
import { IdexService } from '../idex.service';
import { FilesComponent } from './files/files.component';
import {FileSizePipe} from '../shared/file-size.pipe';

@Injectable()
export class UploadService {
   public totalfile: any;
   public sum_count = 0;
   private sum = 0;
   limitSize = 10485760;
   limit: any;

   constructor(private service: IdexService, private filesize: FileSizePipe) {}

   getKeyUpload() {
      return this.service.get('/upload');
   }

   cancelUpload(key: string) {
      return this.service.post('/cancel/upload/' + key, null);
   }

   getUploadtoAlfresco(key: any, name: any, path: any, mimeType: any, folder: any, count: any) {
      const body = {
         name: name,
         destination: path,
         mimeType: mimeType,
         tin: folder.tin,
         id: folder.selectFile ? folder.selectFile.id : ''
      };
      return this.service.post('/upload/' + key, body)
                 .subscribe(() => {
                    this.checkUptoAlfresco(folder);
                    if (folder.selectFile) { folder.selectFile.id = null; }
                 }, () => {
                    this.checkUptoAlfresco(folder);
                 });
   }

   checkUptoAlfresco(folder: FilesComponent) {
      this.sum_count++;
      folder.successUpload1(this.sum_count);
   }

   uploadFile(file: File, path: any, folder: any, key: any, count: any, totalfile: any) {
      const offset = 0;
      const file_size = file.size;
      const fix_size = 1048576; // 1MB
      const ending = Math.min(offset + fix_size, file_size);
      this.totalfile = totalfile;
      this.sliceFile(file, offset, ending, file_size, key, path, folder, count);
   }

   sliceFile(file: any, offset: any, ending: any, file_size: any, key: any, path: any, folder: any, count: any) {

      const fix_size = 1048576; // 1MB

      const xhr: XMLHttpRequest = new XMLHttpRequest();

      xhr.onload = () => {
         if (xhr.status === 308) {
            if (!file.cancel) {
               const percent = (offset * 100 / file.size) || 0;
               folder.onProgressLoad2(percent.toFixed(0), count, file);

               offset = offset + fix_size;
               ending = Math.min(offset + fix_size, file_size);
               this.sliceFile(file, offset, ending, file_size, key, path, folder, count);
            }

         } else if (xhr.status === 201) {
            folder.onProgressLoad2(100, count, file);
            return this.getUploadtoAlfresco(key, file.webkitRelativePath || file.name, path, file.type, folder, count);
         }
      };
      xhr.onreadystatechange = (event) => {
         if (xhr.readyState === 4) {   // if complete
            if (xhr.status === 201) {  // check if "OK" (200)
               // success
            } else if (xhr.status === 308) {
               // continue
            } else if (xhr.status === 200) {
               // This is intentional.
            } else if (xhr.status === 404) {
               // This is intentional.
            } else {
               setTimeout(() => {
                  this.sliceFile(file, offset, ending, file_size, key, path, folder, count);
               }, 10000);
            }
         }
      };
      xhr.open('PUT', this.service.url + '/upload/' + key, true);
      xhr.setRequestHeader('x-auth-token', this.service.user.token);
      xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (ending - 1) + '/' + file_size);
      const blob = file.slice.call(file, offset, ending);
      xhr.send(blob);
   }

   getLimitSize() {
      this.service.get('upload/limitsize')
         .subscribe(value => {
            this.limitSize = value;
            this.limit = this.filesize.transform(this.limitSize);
         });
   }
}
